import { cn } from '../../utils'
import * as RadixTooltip from '@radix-ui/react-tooltip'
import { getContentClass, getMessageClassNames } from './Tooltip.styles'
import { TooltipProps } from './Tooltip.types'

/**
 *
 * @param message - The message of the tooltip
 * @param trigger - The trigger of the tooltip
 * @param classNames - The class names of the tooltip
 * @param messageClassNames - The class names of the tooltip message
 * @param withArrow - Whether the tooltip has an arrow or not
 * @param contentSide - The side of the tooltip
 *
 */
export const Tooltip = ({
    message,
    trigger,
    classNames,
    messageClassNames,
    withArrow = true,
    contentSide = 'top',
    iconClassName,
}: TooltipProps) => {
    return (
        <RadixTooltip.Provider>
            <RadixTooltip.Root>
                <RadixTooltip.Trigger asChild>{trigger}</RadixTooltip.Trigger>
                <RadixTooltip.Portal>
                    <RadixTooltip.Content
                        className={cn(getContentClass(), classNames)}
                        side={contentSide}
                    >
                        <span
                            className={cn(
                                getMessageClassNames(),
                                messageClassNames
                            )}
                        >
                            {message}
                        </span>
                        {withArrow && (
                            <RadixTooltip.Arrow
                                className={cn(
                                    'fill-background-base stroke-[#F5F6F7]',
                                    iconClassName
                                )}
                            />
                        )}
                    </RadixTooltip.Content>
                </RadixTooltip.Portal>
            </RadixTooltip.Root>
        </RadixTooltip.Provider>
    )
}
